export enum CmsEntities {
    TEMPLATES = 'templates',
    RELEASES = 'releases',
    EMOJI = 'emoji',
    SEGMENTS = 'segments',
    SEGMENTS_MOST_RELEVANT = 'segments/most-relevent',
}
